import { atom } from 'jotai'

export const companyAtom = atom({ admins : [{_id : ""}]})
export const companyAtomFixer = ""